import { Component, Inject, OnInit } from '@angular/core';
// esto es loq ue declara y el componente se declara en en module 
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialogmensaje3botones',
  templateUrl: './dialogmensaje3botones.component.html',
  styleUrls: ['./dialogmensaje3botones.component.css']
})
export class Dialogmensaje3botonesComponent implements OnInit {

  respuestaseleccion= "";

  constructor(
    @Inject (MAT_DIALOG_DATA) public message,
    public dialogRef : MatDialogRef <Dialogmensaje3botonesComponent>
  ) { }

  ngOnInit() {

  
  }


  onClose() {
      this.dialogRef.close("cancelado");
    }


clickPermanente() {
  this.dialogRef.close("permanente");
}


clickTemporal(){
  this.dialogRef.close("temporal");
}


}
